/**
 * en-GB messages added by Phase 3 task S29 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s29EnGB = {
    'nav.occupancy': 'Live occupancy',
    'occupancy.level.none': 'Not set',
    'occupancy.level.green': 'Green',
    'occupancy.level.amber': 'Amber',
    'occupancy.level.red': 'Red',
    'occupancy.col.time': 'Time',
    'occupancy.col.people': 'People on site',
    'occupancy.col.capacity': 'Capacity',
    'occupancy.col.percent': 'Percent of capacity',
};
//# sourceMappingURL=s29.js.map